import { render, staticRenderFns } from "./pic-preview.vue?vue&type=template&id=7b07ae48&"
import script from "./pic-preview.vue?vue&type=script&lang=ts&"
export * from "./pic-preview.vue?vue&type=script&lang=ts&"
import style0 from "./pic-preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports